import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Scarring forms
   */

  {
    // 1
    field: 'scarImages',
    label:
      'Please upload images of the scar. If it is on a sensitive area feel free not to share.',
    type: 'image_list',
    answer: {
      option: {
        buttonLabel: 'Choose File',
        addLabel: '+Add another',
        resourceId: 'scarImages',
        limit: 20,
        required: false
      }
    }
  },
  {
    // 2
    field: 'scarCause',
    label: 'What is the cause of the scar?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'burn', value: 'burn' },
        { key: 'surgery', value: 'surgery' },
        { key: 'stretchMarks', value: 'stretch marks' },
        { key: 'injury', value: 'injury' },
        { key: 'sunBurn', value: 'sun burn' },
        { key: 'keloid', value: 'keloid' },
        { key: 'hyperpigment', value: 'hyperpigmentation' },
        { key: 'acneCondition', value: 'previous acne/skin condition' },
        {
          key: 'medication',
          value: 'medication (allergic reaction, radiation therapy)'
        },
        { key: 'other', value: 'other' }
      ]
    }
  },
  {
    // 3
    field: 'scarBody',
    label: 'What part of the body is affected?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'scarBodyDesc',
      rows: 5,
      placeholder: 'Please type here...'
    }
  },
  {
    // 4
    field: 'scarDescSkin',
    label: 'How would you describe your skin?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'veryDry', value: 'very dry' },
        { key: 'dry', value: 'dry' },
        { key: 'average', value: 'average' },
        { key: 'oily', value: 'oily' },
        { key: 'veryOily', value: 'very oily' },
        { key: 'sensitive', value: 'sensitive' },
        { key: 'combination', value: 'combination' },
        { key: 'other', value: 'other' }
      ]
    }
  },
  {
    // 5
    field: 'scarPrescription',
    label: 'Have you ever tried any prescription products for your scarring?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'preYes',
          value: 'Yes',
          answer: {
            label: 'What was the medication, dosage, and duration of use?',
            type: 'text',
            name: 'medication',
            placeholder: 'Please type here...'
          }
        },
        { key: 'preNo', value: 'No' }
      ]
    }
  },
  {
    // 6
    field: 'scarOverCounter',
    label:
      'Have you ever tried any over-the-counter (non-prescription) treatments?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'vitaminE', value: 'Vitamin E' },
        { key: 'bioOil', value: 'BioOil' },
        { key: 'siliconeScarGel', value: 'Silicone Scar Gel' },
        { key: 'rosehipOil', value: 'Rosehip Oil' }
      ]
    }
  },
  {
    // 7
    field: 'scarSPF',
    label: 'Do you put sunscreen, or anything with SPF?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'scarSPFDesc',
      rows: 5,
      placeholder: 'Please type here...'
    }
  },
  {
    // 8
    field: 'scarWear',
    label: 'Do you wear make up?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'scarWearDesc',
      rows: 5,
      placeholder: 'Please type here...'
    }
  },
  {
    // 9
    field: 'scarPregnant',
    label:
      'Are you pregnant, breastfeeding, or planning to become pregnant in the near future?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'scarPregnantDesc',
      rows: 5,
      placeholder: 'Please type here...'
    }
  }
];

export default questionsModels;
